'use client'

import { useEffect, useState } from 'react'
import { getCountdownParts, type CountdownParts } from '@/utils/campaign'

export function useCountdown(endDate: string | null | undefined, enabled: boolean = true): CountdownParts | null {
  const [now, setNow] = useState<Date | null>(null)

  useEffect(() => {
    if (!endDate || !enabled) return
    setNow(new Date())
    const interval = setInterval(() => setNow(new Date()), 1000)
    return () => clearInterval(interval)
  }, [endDate, enabled])

  if (!endDate || !enabled || !now) return null
  return getCountdownParts(endDate, now)
}
